module.exports = __webpack_public_path__ + "media/images/favicon-32x32-1a6a5252a24d50374a95cfc597f5fa80.png";